import html2canvas from 'html2canvas';

export function copyTableToImage(tableElement) {
  html2canvas(tableElement, {
    backgroundColor: '#ffffff' // 设置背景颜色为白色
  }).then(canvas => {
    // 创建一个新的Canvas元素，用于添加水印
    const watermarkedCanvas = document.createElement('canvas');
    watermarkedCanvas.width = canvas.width;
    watermarkedCanvas.height = canvas.height;

    const ctx = watermarkedCanvas.getContext('2d');
    ctx.drawImage(canvas, 0, 0);

    // 添加水印
    const watermarkText = 'VIP 客户';
    ctx.font = 'bold 30px Arial'; // 设置字体为粗体
    ctx.fillStyle = 'rgba(255, 0, 0, 0.2)'; // 将水印颜色改为红色，透明度保持不变
    ctx.textAlign = 'center';
    ctx.textBaseline = 'middle';

    // 保存当前状态
    ctx.save();

    // 设置旋转中心点
    ctx.translate(canvas.width / 3, canvas.height / 2);

    // 旋转45度
    ctx.rotate(30 * Math.PI / 180);

    // 绘制水印
    ctx.fillText(watermarkText, 0, 0);

    // 恢复之前的状态
    ctx.restore();

    // 将 Canvas 内容转换为 Blob
    watermarkedCanvas.toBlob(blob => {
      if (navigator.clipboard && navigator.clipboard.write) {
        // 创建 ClipboardItem
        const clipboardItem = new ClipboardItem({
          'image/png': blob
        });

        // 写入剪贴板
        navigator.clipboard.write([clipboardItem])
          .then(() => {
            console.log('图像已成功复制到剪贴板');
            alert('图像已成功复制到剪贴板');

          })
          .catch(err => {
            console.error('无法复制图像到剪贴板', err);
            alert('无法复制图像到剪贴板');

          });
      } else {
        console.error('Clipboard API 不可用');
        alert('Clipboard API 不可用');
      }
    }, 'image/png');
  });
}

